
import { GoogleOAuthProvider } from "@react-oauth/google"
import { PremiumCalcalistPaywallDesktop } from "../../../calcalist/calcalistPaywallForms/desktop/premiumCalcalistPaywallDesktop";
import { PremiumCalcalistPaywallMobile } from "../../../calcalist/calcalistPaywallForms/mobile/premiumCalcalistPaywallMobile"
import { useRedirect } from "../../../../../global/paywall/useRedirect";
import { useState, useEffect, useCallback } from "react"
import { getPaywallSettingsFromLocalStorage, PAYWALL_LOCAL_STORAGE_KEY } from "../../../../../global/paywall/authOperations";
import { getPaywallAccessData } from "../../../../../global/paywall/paywallApiUrls";
import { CustomerAccessData } from "../../../../../global/paywall/paywallInterfaces";
import * as axios from "axios";
import { LinkTargetProperties } from "../../../../../global/components/linkSettings/interfaces";


declare const window: Window & {
    PAYWALL_GOOGLE_CLIENT_ID:string
    YitPaywall:{
          removePaywallData?: (key: string) => boolean
    }
}

const GOOGLE_CLIENT_ID = typeof window !== "undefined" && window && window.PAYWALL_GOOGLE_CLIENT_ID || " ";

interface LegalLink {
    url: string;
    target: LinkTargetProperties;
}

interface CalcalistUserAuthComponentaWrapperProps {
    isMobile?: boolean;
    postLoginUrl: string;
    legalLinks: {terms: LegalLink; privacy: LegalLink};
}
export const CalcalistUserAuthComponentaWrapper = (props: CalcalistUserAuthComponentaWrapperProps) => {
    const [isRedirecting, setIsRedirecting] = useState(false);
    const { isMobile, postLoginUrl,legalLinks } = props;

    useRedirect({ fallbackUrl: postLoginUrl, enabled: isRedirecting });

    const checkUserAccess = useCallback(async () => { 
        try {
            const userDetails = getPaywallSettingsFromLocalStorage();
            if (!userDetails) return; 
            const res = await axios.get(getPaywallAccessData());
            const customerData = res.data as CustomerAccessData;
            if (customerData) {
                setIsRedirecting(true);
            } else {
                typeof window !== "undefined" && window && window.YitPaywall && typeof window.YitPaywall.removePaywallDataObj === "function" && window.YitPaywall.removePaywallDataObj();
                window.location.reload();
            }
        } catch (error) {
            console.error("Error fetching customer data:", error);
        }
    }, []);

    useEffect(() => {
        checkUserAccess(); 
    }, [checkUserAccess]); 

    useEffect(() => {
        if (!GOOGLE_CLIENT_ID || GOOGLE_CLIENT_ID === " ") {
            console.error("GOOGLE_CLIENT_ID is undefined or empty. Please provide a valid client ID.");
        }
    }, [GOOGLE_CLIENT_ID]);

    return (
        <div className="calcalist-page-auth-wrapper">
            <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
                {isMobile ? <PremiumCalcalistPaywallMobile setIsRedirecting={setIsRedirecting} legalLinks={legalLinks} /> : <PremiumCalcalistPaywallDesktop setIsRedirecting={setIsRedirecting} legalLinks={legalLinks} />}
            </GoogleOAuthProvider>
        </div>
    )
}

CalcalistUserAuthComponentaWrapper.siteScriptName = "CalcalistUserAuthComponentaWrapper"
